"use client";

import { useState, useEffect, useMemo } from "react";
import styles from "../../Supplier Management/css/supplierManagement.module.css";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import Button from "../../../../components/Button";
import SearchBar from "../../../../components/SearchBar";
import FilterButtons from "../../../../components/universal-filter-tabs.jsx";

const supplierRows = [
  {
    supplierName: "ABC Supplies",
    contact: { name: "John Doe", phone: "+1 234 567 890", email: "alee@yahoo.com" },
    totalOrders: 82,
    lastSupplied: "2024-06-06",
  },
  {
    supplierName: "XYZ Traders",
    contact: { name: "Jane Smith", phone: "+1 987 654 321", email: "omartinez@yahoo.com" },
    totalOrders: 68,
    lastSupplied: "2024-08-18",
  },
  {
    supplierName: "FreshGoods Ltd",
    contact: { name: "Mark Owen", phone: "+1 555 678 123", email: "omartinez@yahoo.com" },
    totalOrders: 24,
    lastSupplied: "2022-01-16",
  },
  {
    supplierName: "SupplyPro Inc",
    contact: { name: "Tina Hall", phone: "+1 444 321", email: "987ehall@hotmail.com" },
    totalOrders: 40,
    lastSupplied: "2025-05-09",
  },
];

export default function SupplierTable({
  suppliers,
  onEdit,
  onEnable,
  onAddNew,
  activeFilter,
  setActiveFilter,
  search,
  setSearch,
  showAddForm
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4;

  const columns = [
    { header: "Supplier Name", accessor: "supplierName" },
    {
      header: "Contact Info",
      accessor: "contact",
      render: (value) => (
        <div>
          <div>{value.name}</div>
          <div>{value.phone}</div>
          <div>{value.email}</div>
        </div>
      ),
    },
    { header: "Total Orders", accessor: "totalOrders" },
    { header: "Last Supplied Date", accessor: "lastSupplied" },
    {
      header: "Action",
      accessor: "action",
      render: (_, row) => (
        row?.disabled ? (
          <Button
            variant="approve"
            className={styles.viewBtn}
            onClick={() => onEnable(row)}
          >
            Enable
          </Button>
        ) : (
          <Button
            variant="primary"
            className={styles.viewBtn}
            onClick={() => onEdit(row)}
          >
            Edit
          </Button>
        )
      ),
    },
  ];

  const filtered = suppliers.filter((s) =>
    (s?.supplierName || '').toLowerCase().includes(search.toLowerCase()) ||
    (s?.contact?.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (s?.contact?.email || '').toLowerCase().includes(search.toLowerCase())
  );

  // Reset pagination when filters/search change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeFilter, search]);

  // Pagination calculations
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const pageData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, currentPage]);
  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [totalPages, currentPage]);

  if (showAddForm) return null;

  return (
    <>
      <div className={styles.headerRow}>
        <h1 className={styles.title} style={{ marginLeft: '0.25rem' }}>Supplier List</h1>
      </div>
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginBottom: '0.75rem' }}>
        <FilterButtons
          buttons={["Dispensary", "Front Shop", "Clinic"]}
          activeButton={activeFilter}
          onButtonClick={setActiveFilter}
        />
      </div>
      <div
        style={{
          maxWidth: 1100,
          width: '100%',
          margin: '0 auto 1rem',
          background: '#ffffff',
          border: '1px solid #e5e7eb',
          borderRadius: 14,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            gap: '0.75rem',
            padding: '0.75rem 1rem'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: '#fff',
              border: '2px solid #e6d8ff',
              borderRadius: 12,
              padding: '0.45rem 0.6rem',
              boxShadow: '0 2px 6px rgba(117,58,172,0.08)'
            }}
          >
            <span className={styles.heroLabel} style={{ marginRight: '0.25rem' }}>Search</span>
            <div style={{ width: 320 }}>
              <SearchBar value={search} onChange={setSearch} placeholder="Search suppliers" />
            </div>
          </div>
          <div style={{ position: 'absolute', right: '1rem', top: '50%', transform: 'translateY(-50%)' }}>
            <Button
              className={styles.addBtn}
              style={{ width: 180, height: 38 }}
              onClick={onAddNew}
            >
              Add New Supplier
            </Button>
          </div>
        </div>
        <div style={{ padding: '0.75rem 1rem 1rem' }}>
          <Table columns={columns} data={pageData} />
          <div className={styles.paginationContainer} style={{ marginTop: '0.75rem' }}>
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
          </div>
        </div>
      </div>
    </>
  );
}
